// Tab state
const storeTab = (tab) => ({ type: "SET_TAB", tab });

export const setTab = storeTab;
